module.exports = __webpack_public_path__ + "img/6.83dd5326.png";